/*
 * @Author: 朱占伟
 * @LastEditors: 朱占伟
 * @description: 数据管理中心
 * @Date: 2021-07-26 11:46:18
 * @LastEditTime: 2021-07-26 11:59:48
 */

// 页面类型
export const PAGETYPES = {
  HOME: 'home', // 首页
  HIDE: 'hide', // 不展示公共顶部
  TABAR: 'tabar', // tabar类型
  OTHER: 'other' // 其他类型
};
